import { trigger, state, style, transition, animate } from '@angular/animations';
import * as i1 from '@angular/common';
import { CommonModule } from '@angular/common';
import * as i0 from '@angular/core';
import { forwardRef, booleanAttribute, Component, ViewEncapsulation, ChangeDetectionStrategy, Inject, Input, EventEmitter, Output, ContentChildren, NgModule } from '@angular/core';
import { PrimeTemplate, SharedModule } from 'primeng/api';
import { DomHandler } from 'primeng/dom';
import { ChevronDownIcon } from 'primeng/icons/chevrondown';
import { ChevronUpIcon } from 'primeng/icons/chevronup';
import { Subject } from 'rxjs';
const _c0 = ["pOrganizationChartNode", ""];
const _c1 = (a0, a1) => ({
  "p-organizationchart-node-content": true,
  "p-organizationchart-selectable-node": a0,
  "p-highlight": a1
});
const _c2 = a0 => ({
  $implicit: a0
});
const _c3 = a0 => ({
  "p-organizationchart-line-top": a0
});
function OrganizationChartNode_tbody_0_div_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r1.node.label);
  }
}
function OrganizationChartNode_tbody_0_div_5_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function OrganizationChartNode_tbody_0_div_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, OrganizationChartNode_tbody_0_div_5_ng_container_1_Template, 1, 0, "ng-container", 6);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r1.chart.getTemplateForNode(ctx_r1.node))("ngTemplateOutletContext", i0.ɵɵpureFunction1(2, _c2, ctx_r1.node));
  }
}
function OrganizationChartNode_tbody_0_ng_container_6_a_1_ng_container_1_ChevronDownIcon_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "ChevronDownIcon", 11);
  }
  if (rf & 2) {
    i0.ɵɵproperty("styleClass", "p-node-toggler-icon");
    i0.ɵɵattribute("data-pc-section", "nodeTogglerIcon");
  }
}
function OrganizationChartNode_tbody_0_ng_container_6_a_1_ng_container_1_ChevronUpIcon_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "ChevronUpIcon", 11);
  }
  if (rf & 2) {
    i0.ɵɵproperty("styleClass", "p-node-toggler-icon");
    i0.ɵɵattribute("data-pc-section", "nodeTogglerIcon");
  }
}
function OrganizationChartNode_tbody_0_ng_container_6_a_1_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, OrganizationChartNode_tbody_0_ng_container_6_a_1_ng_container_1_ChevronDownIcon_1_Template, 1, 2, "ChevronDownIcon", 10)(2, OrganizationChartNode_tbody_0_ng_container_6_a_1_ng_container_1_ChevronUpIcon_2_Template, 1, 2, "ChevronUpIcon", 10);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.node.expanded);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r1.node.expanded);
  }
}
function OrganizationChartNode_tbody_0_ng_container_6_a_1_span_2_1_ng_template_0_Template(rf, ctx) {}
function OrganizationChartNode_tbody_0_ng_container_6_a_1_span_2_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, OrganizationChartNode_tbody_0_ng_container_6_a_1_span_2_1_ng_template_0_Template, 0, 0, "ng-template");
  }
}
function OrganizationChartNode_tbody_0_ng_container_6_a_1_span_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 12);
    i0.ɵɵtemplate(1, OrganizationChartNode_tbody_0_ng_container_6_a_1_span_2_1_Template, 1, 0, null, 6);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(4);
    i0.ɵɵattribute("data-pc-section", "nodeTogglerIcon");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r1.chart.togglerIconTemplate)("ngTemplateOutletContext", i0.ɵɵpureFunction1(3, _c2, ctx_r1.node.expanded));
  }
}
function OrganizationChartNode_tbody_0_ng_container_6_a_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "a", 8);
    i0.ɵɵlistener("click", function OrganizationChartNode_tbody_0_ng_container_6_a_1_Template_a_click_0_listener($event) {
      i0.ɵɵrestoreView(_r3);
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.toggleNode($event, ctx_r1.node));
    })("keydown.enter", function OrganizationChartNode_tbody_0_ng_container_6_a_1_Template_a_keydown_enter_0_listener($event) {
      i0.ɵɵrestoreView(_r3);
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.toggleNode($event, ctx_r1.node));
    })("keydown.space", function OrganizationChartNode_tbody_0_ng_container_6_a_1_Template_a_keydown_space_0_listener($event) {
      i0.ɵɵrestoreView(_r3);
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.toggleNode($event, ctx_r1.node));
    });
    i0.ɵɵtemplate(1, OrganizationChartNode_tbody_0_ng_container_6_a_1_ng_container_1_Template, 3, 2, "ng-container", 0)(2, OrganizationChartNode_tbody_0_ng_container_6_a_1_span_2_Template, 2, 5, "span", 9);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵattribute("data-pc-section", "nodeToggler");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r1.chart.togglerIconTemplate);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.chart.togglerIconTemplate);
  }
}
function OrganizationChartNode_tbody_0_ng_container_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, OrganizationChartNode_tbody_0_ng_container_6_a_1_Template, 3, 3, "a", 7);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r1.leaf);
  }
}
function OrganizationChartNode_tbody_0_ng_container_11_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "td");
    i0.ɵɵelement(2, "div", 3);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵattribute("data-pc-section", "lineCell")("colspan", ctx_r1.colspan);
    i0.ɵɵadvance();
    i0.ɵɵattribute("data-pc-section", "lineDown");
  }
}
function OrganizationChartNode_tbody_0_ng_container_12_ng_template_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "td", 14);
    i0.ɵɵtext(1, "\xA0");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(2, "td", 15);
    i0.ɵɵtext(3, "\xA0");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const first_r4 = ctx.first;
    const last_r5 = ctx.last;
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(4, _c3, !first_r4));
    i0.ɵɵattribute("data-pc-section", "lineLeft");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(6, _c3, !last_r5));
    i0.ɵɵattribute("data-pc-section", "lineRight");
  }
}
function OrganizationChartNode_tbody_0_ng_container_12_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, OrganizationChartNode_tbody_0_ng_container_12_ng_template_1_Template, 4, 8, "ng-template", 13);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r1.node.children);
  }
}
function OrganizationChartNode_tbody_0_td_14_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "td", 16);
    i0.ɵɵelement(1, "table", 17);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const child_r6 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵattribute("data-pc-section", "nodeCell");
    i0.ɵɵadvance();
    i0.ɵɵproperty("node", child_r6)("collapsible", ctx_r1.node.children && ctx_r1.node.children.length > 0);
  }
}
function OrganizationChartNode_tbody_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "tbody")(1, "tr")(2, "td")(3, "div", 1);
    i0.ɵɵlistener("click", function OrganizationChartNode_tbody_0_Template_div_click_3_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onNodeClick($event, ctx_r1.node));
    });
    i0.ɵɵtemplate(4, OrganizationChartNode_tbody_0_div_4_Template, 2, 1, "div", 0)(5, OrganizationChartNode_tbody_0_div_5_Template, 2, 4, "div", 0)(6, OrganizationChartNode_tbody_0_ng_container_6_Template, 2, 1, "ng-container", 0);
    i0.ɵɵelementEnd()()();
    i0.ɵɵelementStart(7, "tr", 2)(8, "td");
    i0.ɵɵelement(9, "div", 3);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(10, "tr", 2);
    i0.ɵɵtemplate(11, OrganizationChartNode_tbody_0_ng_container_11_Template, 3, 3, "ng-container", 0)(12, OrganizationChartNode_tbody_0_ng_container_12_Template, 2, 1, "ng-container", 0);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(13, "tr", 4);
    i0.ɵɵtemplate(14, OrganizationChartNode_tbody_0_td_14_Template, 2, 3, "td", 5);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵattribute("data-pc-section", "body");
    i0.ɵɵadvance();
    i0.ɵɵattribute("data-pc-section", "row");
    i0.ɵɵadvance();
    i0.ɵɵattribute("colspan", ctx_r1.colspan)("data-pc-section", "cell");
    i0.ɵɵadvance();
    i0.ɵɵclassMap(ctx_r1.node.styleClass);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(26, _c1, ctx_r1.chart.selectionMode && ctx_r1.node.selectable !== false, ctx_r1.isSelected()));
    i0.ɵɵattribute("data-pc-section", "node");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r1.chart.getTemplateForNode(ctx_r1.node));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.chart.getTemplateForNode(ctx_r1.node));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.collapsible);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngClass", !ctx_r1.leaf && ctx_r1.node.expanded ? "p-organizationchart-node-visible" : "p-organizationchart-node-hidden")("@childState", "in");
    i0.ɵɵattribute("data-pc-section", "lines");
    i0.ɵɵadvance();
    i0.ɵɵattribute("data-pc-section", "lineCell")("colspan", ctx_r1.colspan);
    i0.ɵɵadvance();
    i0.ɵɵattribute("data-pc-section", "lineDown");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngClass", !ctx_r1.leaf && ctx_r1.node.expanded ? "p-organizationchart-node-visible" : "p-organizationchart-node-hidden")("@childState", "in");
    i0.ɵɵattribute("data-pc-section", "lines");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.node.children && ctx_r1.node.children.length === 1);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.node.children && ctx_r1.node.children.length > 1);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngClass", !ctx_r1.leaf && ctx_r1.node.expanded ? "p-organizationchart-node-visible" : "p-organizationchart-node-hidden")("@childState", "in");
    i0.ɵɵattribute("data-pc-section", "nodes");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r1.node.children);
  }
}
const _c4 = a0 => ({
  "p-organizationchart p-component": true,
  "p-organizationchart-preservespace": a0
});
function OrganizationChart_table_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "table", 2);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("collapsible", ctx_r0.collapsible)("node", ctx_r0.root);
  }
}
let OrganizationChartNode = /*#__PURE__*/(() => {
  class OrganizationChartNode {
    cd;
    node;
    root;
    first;
    last;
    collapsible;
    chart;
    subscription;
    constructor(chart, cd) {
      this.cd = cd;
      this.chart = chart;
      this.subscription = this.chart.selectionSource$.subscribe(() => {
        this.cd.markForCheck();
      });
    }
    get leaf() {
      if (this.node) {
        return this.node.leaf == false ? false : !(this.node.children && this.node.children.length);
      }
    }
    get colspan() {
      if (this.node) {
        return this.node.children && this.node.children.length ? this.node.children.length * 2 : null;
      }
    }
    onNodeClick(event, node) {
      this.chart.onNodeClick(event, node);
    }
    toggleNode(event, node) {
      node.expanded = !node.expanded;
      if (node.expanded) this.chart.onNodeExpand.emit({
        originalEvent: event,
        node: this.node
      });else this.chart.onNodeCollapse.emit({
        originalEvent: event,
        node: this.node
      });
      event.preventDefault();
    }
    isSelected() {
      return this.chart.isSelected(this.node);
    }
    ngOnDestroy() {
      this.subscription.unsubscribe();
    }
    static ɵfac = function OrganizationChartNode_Factory(t) {
      return new (t || OrganizationChartNode)(i0.ɵɵdirectiveInject(forwardRef(() => OrganizationChart)), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: OrganizationChartNode,
      selectors: [["", "pOrganizationChartNode", ""]],
      hostAttrs: [1, "p-element"],
      inputs: {
        node: "node",
        root: [2, "root", "root", booleanAttribute],
        first: [2, "first", "first", booleanAttribute],
        last: [2, "last", "last", booleanAttribute],
        collapsible: [2, "collapsible", "collapsible", booleanAttribute]
      },
      features: [i0.ɵɵInputTransformsFeature],
      attrs: _c0,
      decls: 1,
      vars: 1,
      consts: [[4, "ngIf"], [3, "click", "ngClass"], [1, "p-organizationchart-lines", 3, "ngClass"], [1, "p-organizationchart-line-down"], [1, "p-organizationchart-nodes", 3, "ngClass"], ["colspan", "2", 4, "ngFor", "ngForOf"], [4, "ngTemplateOutlet", "ngTemplateOutletContext"], ["tabindex", "0", "class", "p-node-toggler", 3, "click", "keydown.enter", "keydown.space", 4, "ngIf"], ["tabindex", "0", 1, "p-node-toggler", 3, "click", "keydown.enter", "keydown.space"], ["class", "p-node-toggler-icon", 4, "ngIf"], [3, "styleClass", 4, "ngIf"], [3, "styleClass"], [1, "p-node-toggler-icon"], ["ngFor", "", 3, "ngForOf"], [1, "p-organizationchart-line-left", 3, "ngClass"], [1, "p-organizationchart-line-right", 3, "ngClass"], ["colspan", "2"], ["pOrganizationChartNode", "", 1, "p-organizationchart-table", 3, "node", "collapsible"]],
      template: function OrganizationChartNode_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵtemplate(0, OrganizationChartNode_tbody_0_Template, 15, 29, "tbody", 0);
        }
        if (rf & 2) {
          i0.ɵɵproperty("ngIf", ctx.node);
        }
      },
      dependencies: () => [i1.NgClass, i1.NgForOf, i1.NgIf, i1.NgTemplateOutlet, ChevronDownIcon, ChevronUpIcon, OrganizationChartNode],
      styles: ["@layer primeng{.p-organizationchart-table{border-spacing:0;border-collapse:separate;margin:0 auto}.p-organizationchart-table>tbody>tr>td{text-align:center;vertical-align:top;padding:0 .75rem}.p-organizationchart-node-content{display:inline-block;position:relative}.p-organizationchart-node-content .p-node-toggler{position:absolute;bottom:-.75rem;margin-left:-.75rem;z-index:2;left:50%;-webkit-user-select:none;user-select:none;cursor:pointer;width:1.5rem;height:1.5rem}.p-organizationchart-node-content .p-node-toggler .p-node-toggler-icon{position:relative;top:.25rem}.p-organizationchart-line-down{margin:0 auto;height:20px;width:1px}.p-organizationchart-line-right,.p-organizationchart-line-left{border-radius:0}.p-organizationchart-selectable-node{cursor:pointer}.p-organizationchart .p-organizationchart-node-hidden{display:none}.p-organizationchart-preservespace .p-organizationchart-node-hidden{visibility:hidden;display:inherit}}\n"],
      encapsulation: 2,
      data: {
        animation: [trigger('childState', [state('in', style({
          opacity: 1
        })), transition('void => *', [style({
          opacity: 0
        }), animate(150)]), transition('* => void', [animate(150, style({
          opacity: 0
        }))])])]
      }
    });
  }
  return OrganizationChartNode;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
/**
 * OrganizationChart visualizes hierarchical organization data.
 * @group Components
 */
let OrganizationChart = /*#__PURE__*/(() => {
  class OrganizationChart {
    el;
    cd;
    /**
     * An array of nested TreeNodes.
     * @group Props
     */
    value;
    /**
     * Inline style of the component.
     * @group Props
     */
    style;
    /**
     * Style class of the component.
     * @group Props
     */
    styleClass;
    /**
     * Defines the selection mode.
     * @group Props
     */
    selectionMode;
    /**
     * Whether the nodes can be expanded or toggled.
     * @group Props
     */
    collapsible;
    /**
     * Whether the space allocated by a node is preserved when hidden.
     * @group Props
     */
    preserveSpace = true;
    /**
     * A single treenode instance or an array to refer to the selections.
     * @group Props
     */
    get selection() {
      return this._selection;
    }
    set selection(val) {
      this._selection = val;
      if (this.initialized) this.selectionSource.next(null);
    }
    /**
     * Callback to invoke on selection change.
     * @param {*} any - selected value.
     * @group Emits
     */
    selectionChange = new EventEmitter();
    /**
     * Callback to invoke when a node is selected.
     * @param {OrganizationChartNodeSelectEvent} event - custom node select event.
     * @group Emits
     */
    onNodeSelect = new EventEmitter();
    /**
     * Callback to invoke when a node is unselected.
     * @param {OrganizationChartNodeUnSelectEvent} event - custom node unselect event.
     * @group Emits
     */
    onNodeUnselect = new EventEmitter();
    /**
     * Callback to invoke when a node is expanded.
     * @param {OrganizationChartNodeExpandEvent} event - custom node expand event.
     * @group Emits
     */
    onNodeExpand = new EventEmitter();
    /**
     * Callback to invoke when a node is collapsed.
     * @param {OrganizationChartNodeCollapseEvent} event - custom node collapse event.
     * @group Emits
     */
    onNodeCollapse = new EventEmitter();
    templates;
    templateMap;
    togglerIconTemplate;
    selectionSource = new Subject();
    _selection;
    initialized;
    selectionSource$ = this.selectionSource.asObservable();
    constructor(el, cd) {
      this.el = el;
      this.cd = cd;
    }
    get root() {
      return this.value && this.value.length ? this.value[0] : null;
    }
    ngAfterContentInit() {
      if (this.templates.length) {
        this.templateMap = {};
      }
      this.templates.forEach(item => {
        if (item.getType() === 'togglericon') {
          this.togglerIconTemplate = item.template;
        } else {
          this.templateMap[item.getType()] = item.template;
        }
      });
      this.initialized = true;
    }
    getTemplateForNode(node) {
      if (this.templateMap) return node.type ? this.templateMap[node.type] : this.templateMap['default'];else return null;
    }
    onNodeClick(event, node) {
      let eventTarget = event.target;
      if (eventTarget.className && (DomHandler.hasClass(eventTarget, 'p-node-toggler') || DomHandler.hasClass(eventTarget, 'p-node-toggler-icon'))) {
        return;
      } else if (this.selectionMode) {
        if (node.selectable === false) {
          return;
        }
        let index = this.findIndexInSelection(node);
        let selected = index >= 0;
        if (this.selectionMode === 'single') {
          if (selected) {
            this.selection = null;
            this.onNodeUnselect.emit({
              originalEvent: event,
              node: node
            });
          } else {
            this.selection = node;
            this.onNodeSelect.emit({
              originalEvent: event,
              node: node
            });
          }
        } else if (this.selectionMode === 'multiple') {
          if (selected) {
            this.selection = this.selection.filter((val, i) => i != index);
            this.onNodeUnselect.emit({
              originalEvent: event,
              node: node
            });
          } else {
            this.selection = [...(this.selection || []), node];
            this.onNodeSelect.emit({
              originalEvent: event,
              node: node
            });
          }
        }
        this.selectionChange.emit(this.selection);
        this.selectionSource.next(null);
      }
    }
    findIndexInSelection(node) {
      let index = -1;
      if (this.selectionMode && this.selection) {
        if (this.selectionMode === 'single') {
          index = this.selection == node ? 0 : -1;
        } else if (this.selectionMode === 'multiple') {
          for (let i = 0; i < this.selection.length; i++) {
            if (this.selection[i] == node) {
              index = i;
              break;
            }
          }
        }
      }
      return index;
    }
    isSelected(node) {
      return this.findIndexInSelection(node) != -1;
    }
    static ɵfac = function OrganizationChart_Factory(t) {
      return new (t || OrganizationChart)(i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: OrganizationChart,
      selectors: [["p-organizationChart"]],
      contentQueries: function OrganizationChart_ContentQueries(rf, ctx, dirIndex) {
        if (rf & 1) {
          i0.ɵɵcontentQuery(dirIndex, PrimeTemplate, 4);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.templates = _t);
        }
      },
      hostAttrs: [1, "p-element"],
      inputs: {
        value: "value",
        style: "style",
        styleClass: "styleClass",
        selectionMode: "selectionMode",
        collapsible: [2, "collapsible", "collapsible", booleanAttribute],
        preserveSpace: [2, "preserveSpace", "preserveSpace", booleanAttribute],
        selection: "selection"
      },
      outputs: {
        selectionChange: "selectionChange",
        onNodeSelect: "onNodeSelect",
        onNodeUnselect: "onNodeUnselect",
        onNodeExpand: "onNodeExpand",
        onNodeCollapse: "onNodeCollapse"
      },
      features: [i0.ɵɵInputTransformsFeature],
      decls: 2,
      vars: 8,
      consts: [[3, "ngStyle", "ngClass"], ["class", "p-organizationchart-table", "pOrganizationChartNode", "", 3, "collapsible", "node", 4, "ngIf"], ["pOrganizationChartNode", "", 1, "p-organizationchart-table", 3, "collapsible", "node"]],
      template: function OrganizationChart_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementStart(0, "div", 0);
          i0.ɵɵtemplate(1, OrganizationChart_table_1_Template, 1, 2, "table", 1);
          i0.ɵɵelementEnd();
        }
        if (rf & 2) {
          i0.ɵɵclassMap(ctx.styleClass);
          i0.ɵɵproperty("ngStyle", ctx.style)("ngClass", i0.ɵɵpureFunction1(6, _c4, ctx.preserveSpace));
          i0.ɵɵattribute("data-pc-section", "root");
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", ctx.root);
        }
      },
      dependencies: [i1.NgClass, i1.NgIf, i1.NgStyle, OrganizationChartNode],
      encapsulation: 2
    });
  }
  return OrganizationChart;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let OrganizationChartModule = /*#__PURE__*/(() => {
  class OrganizationChartModule {
    static ɵfac = function OrganizationChartModule_Factory(t) {
      return new (t || OrganizationChartModule)();
    };
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: OrganizationChartModule
    });
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [CommonModule, ChevronDownIcon, ChevronUpIcon, SharedModule, SharedModule]
    });
  }
  return OrganizationChartModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Generated bundle index. Do not edit.
 */

export { OrganizationChart, OrganizationChartModule, OrganizationChartNode };
